import { Injectable } from '@angular/core';
import { GlobalsService } from '@services/global.service';
import AppConfiguration from '@hal.common.ui/utilities/AppConfig';
import { HttpResponse } from '@angular/common/http';
import { StockGroupsService as SDKStockGroupsService } from '@modules/SDKs/sysnetApi/api/stockGroups.service';
import { GroupQuery, GroupSummaryQuery, StockGroupInsert, StockGroupUpdate, StockGroupView } from '@modules/SDKs/sysnetApi';
import { ServicesWrappingSysnetSDK } from './ServicesWrappingSysnetSDK';

@Injectable({
    providedIn: 'root'
})
export class StockGroupsService extends ServicesWrappingSysnetSDK {
    private orgId: string;

    constructor(private sdkStockGroupsService: SDKStockGroupsService, private globals: GlobalsService) {
        super([sdkStockGroupsService], globals);
        this.globals.$state.subscribe((newState) => {
            if (newState) { this.orgId = newState.selectedOrganisation?._id; }
        });
    }

    // Get StockGroup
    public async getStockGroup(stockGroupId: number, view?: string): Promise<HttpResponse<StockGroupView>> {
        return this.sdkStockGroupsService.stockGroupsIdGet(stockGroupId, AppConfiguration.rsh.getStrVal('rid'), view, 'response').toPromise();
    }

    // Search StockGroups
    public async searchStockGroups(
        group?: GroupQuery,
        groupSummary?: GroupSummaryQuery,
        totalSummary?: GroupSummaryQuery,
        sort?: string,
        limit?: number,
        offset?: number,
        view?: string,
        search?: object,
        searchDistinct?: string): Promise<HttpResponse<StockGroupView[]>> {
        return this.sdkStockGroupsService.stockGroupsGet(AppConfiguration.rsh.getStrVal('rid'), view,
            this.stringify(group), this.stringify(groupSummary), this.stringify(totalSummary), searchDistinct, sort, limit, offset,
            this.stringify(search), null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null,
            null, null, null, null, null, this.orgId, null, 'response').toPromise();
    }

    // Insert StockGroup
    public async insertStockGroup(stockGroup: StockGroupInsert): Promise<HttpResponse<StockGroupView>> {
        return this.sdkStockGroupsService.stockGroupsPost(stockGroup, AppConfiguration.rsh.getStrVal('rid'), 'response').toPromise();
    }

    // Update StockGroup
    public async updateStockGroup(stockGroupId: number, stockGroup: StockGroupUpdate): Promise<HttpResponse<StockGroupView[]>> {
        return this.sdkStockGroupsService.stockGroupsIdPut(stockGroupId, stockGroup, AppConfiguration.rsh.getStrVal('rid'), 'response').toPromise();
    }

    // Delete StockGroup
    public async deleteStockGroup(stockGroupId: number): Promise<HttpResponse<StockGroupView>> {
        return this.sdkStockGroupsService.stockGroupsIdDelete(stockGroupId, AppConfiguration.rsh.getStrVal('rid'), 'response').toPromise();
    }

}
